import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";
import useWhitelabel from "hooks/useWhitelabel";
// The legacy page carries the whitelabel header/footer; V2 is Amber-branded only.
import WhitelabelPrivacy from "@Pages/Privacy";

const AsyncPrivacyV2 = loadable(() => import("./PrivacyV2"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const { isWhitelabel } = useWhitelabel();

  if (isWhitelabel) return <WhitelabelPrivacy {...props} />;

  return (
    <ErrorBoundary>
      <AsyncPrivacyV2 {...props} />
    </ErrorBoundary>
  );
};
